<template>

  <v-app class="grey lighten-4">
    <Navbar v-if="!isGameRunning"/>
    
    <v-content>
      
     
      <transition name="fade">
        <router-view></router-view>
      </transition>

      <v-snackbar
        v-if="alerted"
        v-model="alert"
        class="warning-snackbar"
        :timeout="0"
        color="warning"
        top
        multi-line
      >
      <span>Hey! Check out my new online MIDI piano and music theory teaching tool Chordace<a href="https://chordace.com/"  target="_blank" style="margin-left: 10px;">Check out Chordace</a></span>
      <v-spacer></v-spacer>
        <v-btn outline @click="dismissAlert">
      
          Dismiss
        </v-btn>
      </v-snackbar>
      <v-snackbar
        justify-center
        class="text-xs-center"
        v-model="snackbar.showing"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        bottom
      >
      {{ snackbar.text }}
      <!-- <v-spacer></v-spacer>
        <v-btn icon @click="snackbar.showing = false">
          <v-icon>close</v-icon>
        </v-btn> -->
      </v-snackbar>

      <!-- Alert dialog -->
      <v-dialog
      v-model="alertDialog.showing"
      :max-width="alertDialog.maxWidth"
      persistent
      :fullscreen="breakpoint.xsOnly"
      :hide-overlay="breakpoint.xsOnly"
    >
      <v-card rounded center>
        <v-toolbar dense flat color="grey darken-3" dark>
          <v-toolbar-title>{{ alertDialog.title }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <p> {{ alertDialog.text }}</p>
          <v-btn
              class="mt-2 mb-2"
              color="teal"
              dark
              block
              @click="alertDialog.showing = false"
              >{{ alertDialog.buttonText }}</v-btn
            >
        </v-card-text>
      </v-card>
    </v-dialog>

    </v-content>
  </v-app>
</template>

<script>

import Navbar from "@/components/Navbar";
import firebase from 'firebase/app';
import db from "@/firebase/init";
import getFirestoreData from "@/mixins/getFirestoreData";

export default {
  name: "App",
  mixins: [getFirestoreData],
  components: {
    Navbar
  },
  data() {
    return {
      timeout: false,
      deboundeFunc: null,
      isMobile: null,
      alert: true
      
    };
  },
  methods: {
    dismissAlert() {
      this.alert = false;
      window.localStorage.setItem('eb-alerted', 'yes');
    },
    updateExercisePlaying() {

      let usr = this.$route.query.usr;
      let type = this.$route.query.type;
      let id = this.$route.query.id;
      let exerciseRouteName;
      let exerciseType;
      let disciplinePlaying;
    

      if (this.$route.path.includes('exercise')) {
        
        if (this.$route.path.includes('user')) {
          this.$store.dispatch('setShowLevels', 'user');
        }
        
        // Cherck if all props in URL have values
        if (usr && type && id) {
        
        // Check which type
        if (type === '1') {
          exerciseRouteName = 'playCompareIntervalSizesUserExercise';
          exerciseType = 'userLevelsCompareIntervalSizes';
          disciplinePlaying = 'standardLevelsCompareIntervalSizes'
        } else if (type === '2') {
          exerciseRouteName = 'playIdentifyIntervalsUserExercise';
          exerciseType = 'userLevelsIdentifyIntervals';
          disciplinePlaying = 'standardLevelsIdentifyIntervals'
        } else if (type === '3') {
          exerciseRouteName = 'playIdentifyChordsUserExercise';
          exerciseType = 'userLevelsIdentifyChords';
          disciplinePlaying = 'standardLevelsIdentifyChords'
        } else if (type === '4') {
          exerciseRouteName = 'playIdentifyChordInversionsUserExercise';
          exerciseType = 'userLevelsIdentifyChordInversions';
          disciplinePlaying = 'standardLevelsIdentifyChordInversions'
        } else if (type === '5') {
          exerciseRouteName = 'playIdentifyScalesUserExercise';
          exerciseType = 'userLevelsIdentifyScales';
          disciplinePlaying = 'standardLevelsIdentifyScales'
        } else {
          console.log('ID is invalid..');
        }

        let docRef = db.collection("users").doc(usr);
        docRef.get().then((doc) => {
          if (doc.exists) {
            const disciplineExercises = doc.data()[exerciseType];
            const exerciseIndex = disciplineExercises.findIndex(
              (exercise) => exercise.id.toString() === id
            );

            const exerciseObj = disciplineExercises[exerciseIndex];
            // Set up exercisePaying object in store:
            const exercisePlaying = {
              exerciseInfo: {
                id: exerciseObj.id,
                title: exerciseObj.title,
                shortDescription: "",
                description: exerciseObj.description
              },
              exerciseData: {
                id: exerciseObj.id,
                soundSequences: exerciseObj.soundSequences,
                randomRoot: exerciseObj.randomRoot,
                harmony: exerciseObj.harmony,
                numberOfQuestions: 20
              }
            }
            
            this.$store.dispatch('setExercisePlaying', exercisePlaying);
            this.$store.dispatch('setDisciplinePlaying', disciplinePlaying);
            
          } else {
            // Doc does not exist
          }
        })
        


        } else {
          this.$store.dispatch('setExercisePlayingBasedOnRoute');
        }
        
      }
    },
    setViewportHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  },
  computed: {
    isGameRunning() {
      return this.$store.getters.getIsGameRunning;
    },
    screenWidth() {
      return this.$vuetify.breakpoint.width;
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    showExerciseDescription() {
      return this.$store.getters.getShowExerciseDescription;
    },
    showExerciseList() {
      return this.$store.getters.getShowExerciseList;
    },
    showUserExerciseDescription() {
      return this.$store.getters.getShowUserExerciseDescription;
    },
    showUserExerciseList() {
      return this.$store.getters.getShowUserExerciseDList;
    },
    showCreateExerciseSettings() {
      return this.$store.getters.getShowCreateExerciseSettings;
    },
    showCreateExerciseSoundSequenceList() {
    return this.$store.getters.getShowCreateExerciseSoundSequenceList;
    },
    snackbar() {
      return this.$store.state.snackbar;
    },
    alertDialog() {
      return this.$store.state.alertDialog;
    },
    alerted() {
      const alerted = window.localStorage.getItem('eb-alerted') || '';
      if (alerted !== 'yes') {
        return true;
      } else {
        return false;
      }
    },

  },
  beforeCreate() {

  },
  created() {

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('setUser', true);
        this.$store.dispatch('setUserObject', user);
        this.getFirestoreData(user.uid);
        
      } else {
        // If user signs out... 
        this.$store.dispatch('setUserObject', user);
        this.$store.dispatch('setUser', false);
        // Flush users scores for standard exercises from store.. Maybe add to a mixin
        let standardExerciseScores = {
          compareIntervalSizesScores: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          identifyIntervalsScores: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          identifyChordsScores: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          identifyChordInversionsScores: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
          identifyScalesScores: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
        }

        let userExercises = {
            userLevelsCompareIntervalSizes: [],
            userLevelsIdentifyChordInversions: [],
            userLevelsIdentifyChords: [],
            userLevelsIdentifyIntervals: [],
            userLevelsIdentifyScales: []
          }
        this.$store.dispatch('setAllStandardExerciseScores', standardExerciseScores);
        
        this.$store.dispatch('setAllUserExercises', userExercises);
      }

    });
    // set up the data in the store
    this.$store.dispatch("getStandardLevels");
    // Set selected levels 
    this.$store.dispatch('initializeSelectedLevels'); // Also in .js to avoid error
    this.$store.dispatch("setSoundSequenceNames");
    this.$store.dispatch("setCurrentRouteName", this.$route.name);
    this.$store.dispatch("setCurrentlySelectedUserDiscipline");
    this.$store.dispatch("setCurrentRoutePath", this.$route.path);
    this.updateExercisePlaying();
    // Set boolean if on mobile device
    // this.isMobile =  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);


    if (this.screenWidth < 600) {
      // Standard Exercises
      this.$store.dispatch('setShowExerciseList', true);
      this.$store.dispatch('setShowExerciseDescription', false); 

      // User Exercises
      this.$store.dispatch('setShowUserExerciseList', true);
      this.$store.dispatch('setShowUserExerciseDescription', false); 

      // Exercise Creator
      this.$store.dispatch('setShowCreateExerciseSoundSequenceList', true);
      this.$store.dispatch('setShowCreateExerciseSettings', false);

    } else {
      // Standard Exercises
      this.$store.dispatch('setShowExerciseList', true);
      this.$store.dispatch('setShowExerciseDescription', true); 
      
      // User Exercises
      this.$store.dispatch('setShowUserExerciseList', true);
      this.$store.dispatch('setShowUserExerciseDescription', true); 

      // Exercise Creator
      this.$store.dispatch('setShowCreateExerciseSoundSequenceList', true);
      this.$store.dispatch('setShowCreateExerciseSettings', true);
    }

  },
  mounted() {
    // Set viewport height for ipad etc...
    this.debounceFunc = () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.setViewportHeight, 200);
    }
    window.addEventListener("resize", this.debounceFunc);

    this.setViewportHeight();
        

  },
  watch: {
    $route() {
      this.$store.dispatch("setCurrentRouteName", this.$route.name);
      this.$store.dispatch("setCurrentRoutePath", this.$route.path);
      this.$store.dispatch("setCurrentlySelectedUserDiscipline");
      // Set the exercisePlaying based on route
      this.updateExercisePlaying();
    },
    screenWidth(screenWidth) {

      if (screenWidth < 600) {
        // If both exercise list and description is visible, show list and hide description 
        if (this.showExerciseDescription === true && this.showExerciseList === true) {
          this.$store.dispatch('setShowExerciseList', true);
          this.$store.dispatch('setShowExerciseDescription', false);
        }
        // If the screen is less than 600 px and the exercise description is already shown, just return.
        if (this.showExerciseDescription) {
          return;
        }
        if (this.showCreateExerciseSettings === true && this.showCreateExerciseSoundSequenceList === true) {
          this.$store.dispatch('setShowCreateExerciseSoundSequenceList', true);
          this.$store.dispatch('setShowCreateExerciseSettings', false);
        }

        if (this.showCreateExerciseSettings) {
          return;
        }

      } else {
        // Show both levels list and description if screen size wider than xs
        
        // Standard Exercises
        this.$store.dispatch('setShowExerciseList', true);
        this.$store.dispatch('setShowExerciseDescription', true);

        // User Exercises
        this.$store.dispatch('setShowUserExerciseList', true);
        this.$store.dispatch('setShowUserExerciseDescription', true);

        // Exercise Creator
        this.$store.dispatch('setShowCreateExerciseSoundSequenceList', true);
        this.$store.dispatch('setShowCreateExerciseSettings', true);
      }
    }
  }
};
</script>

<style>
html {
  touch-action: manipulation;
  background: #f5f5f5;
  overscroll-behavior: contain;
}
body {
  height: 100vh;
    height: calc(var(--vh, 1vh) * 100);

}
.fade-enter-active, .fade-leave-active {
  transition: opacity .05s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.v-snack__content {
  justify-content: center;
}
.warning-snackbar .v-snack__content {
  justify-content: left;
}

</style>
